import { asyncRouterMap, constantRouterMap } from '@/config/routerconfig'
import { PageView } from '@/layouts'
function generator(routerMap) {

    return routerMap.map(item => {
        // ======================================
        // item.nameEs = "666"
        // ======================================
        const { hidden, component, menuIcon: icon, menuPath, parentId } = item || {}
        const currentRouter = {
            // If route is set with path, then as default path, otherwise Route address Dynamically concatenate to generate /dashboard/workplace
            path: item.menuPath,
            hidden: !!hidden,
            // Route name, recommended to be unique
            name: item.nameEn || '',
            // The page corresponding to this route Component :Scheme1
            // component: constantRouterComponents[item.component || item.key],
            // The page corresponding to this route Component :Scheme2 (Dynamic loading)
            component: item.component ? () =>
                import(`@/views${item.component}`) : PageView,
            // component: item.component ? () => import(`@/views/operation/QueueList`) : PageView,

            // meta: Page title, Menu icon, Page permission(For directive permission use, can be removed)
            meta: { title: item.nameEn, enTitle: item.nameEn, icon: icon || undefined, nameAr: item.nameAr, nameCn: item.nameCn, nameEn: item.nameEn, nameEs: item.nameEs, nameFr: item.nameFr }
        }
        // Whether has sub-menu, and process recursively
        if (item.children && item.children.length > 0) {
            // Recursion
            currentRouter.children = generator(item.children)
        }

        return currentRouter
    })
}

const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: [],
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers
            state.routers = constantRouterMap.concat(routers)
        }
    },
    actions: {
        GenerateRoutes({ commit }, data) {
            return new Promise(resolve => {
                const { menus } = data
                asyncRouterMap[0].children = generator(menus)
                commit('SET_ROUTERS', asyncRouterMap)
                resolve(asyncRouterMap)
            })
        }
    }
}

export default permission